var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMastercard = function SvgMastercard(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    style: {
      height: 20,
      width: 32,
      userSelect: "none"
    },
    viewBox: "0 0 32 21"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "mastercard"
  }, /*#__PURE__*/React.createElement("g", {
    id: "card",
    transform: "translate(0 2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "shape",
    fill: "#003663",
    d: "M26.58 19H2.42A2.4 2.4 0 0 1 0 16.62V2.38A2.4 2.4 0 0 1 2.42 0h24.16A2.4 2.4 0 0 1 29 2.38v14.25A2.4 2.4 0 0 1 26.58 19z"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "shape",
    cx: 10.5,
    cy: 9.5,
    r: 6.5,
    fill: "#EB1C26"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "shape",
    cx: 18.5,
    cy: 9.5,
    r: 6.5,
    fill: "#F99F1B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "shape",
    fill: "#EF5D20",
    d: "M14.5 4.38a6.49 6.49 0 0 0 0 10.24 6.49 6.49 0 0 0 0-10.24z"
  }))))));
};
export { SvgMastercard as ReactComponent };